import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import Card from "../../components/Card/Card";
import useAuth from "../../hooks/useAuth";
import useApplication from "../../hooks/useApplication";
import {
  Column,
  Form,
  Row,
  TextArea,
  TextInput,
} from "carbon-components-react";
import CancelButton from "../../components/Buttons/CancelButton";
import { ButtonSet } from "carbon-components-react";
import http from "../../http-common";
import useGet from "../../hooks/useGet";
import GenericCombo from "../../components/Combos/GenericCombo";

const JuryApplicationPage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { application } = useApplication(uuid);
  const { user } = useAuth();
  const [canScore, setCanScore] = useState(true);
  const { data: academicLevels } = useGet("/utils/academic-levels");

  const { register, handleSubmit, reset } = useForm();

  const checkCanScore = async () => {
    try {
      const response = await http.get(
        `/applications/evaluation/can-score?username=${user.username}&uuid=${uuid}`
      );
      // setCanScore(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    reset(application);
    checkCanScore();
  }, [uuid, application]);

  return (
    <>
      <Card title="Candidatura">
        <Form>
          <fieldset className="bx--fieldset">
            <Row>
              <Column sm={12} md={6} lg={6}>
                <TextInput
                  id="academicLevelDesc"
                  labelText="A10. Nível Académico"
                  disabled={true}
                  {...register("academicLevelDesc")}
                />
              </Column>
            </Row>
          </fieldset>
          <fieldset className="bx--fieldset">
            <Row>
              <Column xsm={12} sm={12} md={12} lg={12}>
                <TextArea
                  id="businessIdea"
                  labelText="D1. Descreva sumariamente a sua Ideia para a sua candidatura e as características inovadoras desta ideia"
                  helperText="[Descreva de forma sumária a sua ideia, destacando as principais características inovadoras/diferenciadoras (científicas, tecnológicas, de mercado, do produto/serviço, processo ou modelo de negócio). Entende-se por inovação/diferenciação qualquer aspecto considerado como novo pelo eventual utilizador/mercado, capaz de garantir diferenciação face aos concorrentes. Descreva o que faría se recebesse financiamento da CPN.]"
                  rows={10}
                  disabled={true}
                  {...register("businessIdea")}
                />
              </Column>
            </Row>
          </fieldset>
          <fieldset className="bx--fieldset">
            <Row>
              <Column sm={12} md={12} lg={12}>
                <TextArea
                  id="ideaProductOrService"
                  labelText="D3. Produtos ou serviços para a ideia"
                  helperText="[Descreva de forma sumária o produto/serviço que pretende produzir/prestar, enunciando as suas principais características e o grau de desenvolvimento.]"
                  rows={8}
                  disabled={true}
                  {...register("ideaProductOrService")}
                />
              </Column>
            </Row>
          </fieldset>
          <fieldset className="bx--fieldset">
            <Row>
              <Column sm={12} md={12} lg={12}>
                <TextArea
                  id="targetCustomerProfile"
                  labelText="D4. Perfil de Clientes-alvo"
                  helperText="[Clientes-alvo são aqueles que a empresa pretende servir e que poderão proporcionar os maiores ganhos. Caracterize-os, justificando com base em critérios comportamentais, demográficos, localização geográfica, benefícios procurados no produto e de necessidade a satisfazer ou padrões de utilização.]"
                  rows={8}
                  disabled={true}
                  {...register("targetCustomerProfile")}
                />
              </Column>
            </Row>
          </fieldset>
          <fieldset className="bx--fieldset">
            <Row>
              <Column sm={12} md={12} lg={12}>
                <TextArea
                  id="workers"
                  labelText="D5. Trabalhadores"
                  helperText="[Número de colaboradores que pretende contratar, sua distribuição por sexo, qualificações, competências necessárias, e regime de contratação.]"
                  rows={8}
                  disabled={true}
                  {...register("workers")}
                />
              </Column>
            </Row>
            <Row className="mt-1">
              <Column sm={12} md={3} lg={3}>
                <TextInput
                  id="numberOfExpectedWorkers"
                  labelText="Número de trabalhadores esperados em 2024"
                  disabled={true}
                  {...register("numberOfExpectedWorkers")}
                />
              </Column>
              <Column sm={12} md={3} lg={3}>
                <TextInput
                  id="numberOfExpectedFemaleWorkers"
                  labelText="Número de trabalhadores do sexo feminino esperados em 2024"
                  disabled={true}
                  {...register("numberOfExpectedFemaleWorkers")}
                />
              </Column>
              <Column sm={12} md={3} lg={3}>
                <TextInput
                  id="numberOfExpectedMaleWorkers"
                  labelText="Número de trabalhadores do sexo masculino esperados em 2024"
                  disabled={true}
                  {...register("numberOfExpectedMaleWorkers")}
                />
              </Column>
              <Column sm={12} md={3} lg={3}>
                <TextInput
                  id="numberOfExpectedWorkersAged18To35"
                  labelText="Número de trabalhadores dos 18 aos 35 anos esperados em 2024"
                  disabled={true}
                  {...register("numberOfExpectedWorkersAged18To35")}
                />
              </Column>
            </Row>
          </fieldset>
          <fieldset className="bx--fieldset">
            <Row>
              <Column sm={12} md={12} lg={12}>
                <TextArea
                  id="howWillEnsureEqualEmploymentOpportunity"
                  labelText="D6. Como vai garantir a igualdade de oportunidade de emprego para homens e mulheres dos 18 aos 35 anos?"
                  rows={8}
                  disabled={true}
                  {...register("howWillEnsureEqualEmploymentOpportunity")}
                />
              </Column>
            </Row>
          </fieldset>
          <div className="form-buttons">
            <ButtonSet>
              {canScore && (
                <Link
                  className="bx--btn bx--btn--primary"
                  style={{ marginRight: "5px" }}
                  to={"../pontuar-candidatura/" + uuid}
                  // target="_blank"
                >
                  Pontuar
                </Link>
              )}

              {/* {canScore && ( */}
              {/* <Link
                className="bx--btn bx--btn--primary"
                style={{ marginRight: "5px" }}
                to={"../pontuar-candidatura/" + uuid}
                target="_blank"
              >
                Pontuar
              </Link> */}
              {/* )} */}

              <CancelButton navigateTo={"../avaliacao-de-candidaturas"} />
            </ButtonSet>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default JuryApplicationPage;
